import { object, string } from 'yup';
const BorrowerInformation = object({
  firstName: string().required('Please provide a valid first name').matches(/^[A-z&.\s-]+$/g, 'Please provide a valid first name'),
  lastName: string().required('Please provide a valid last name').matches(/^[A-z&.\s-]+$/g, 'Please provide a valid last name'),
  suffix: string().nullable(),
  email: string().required('Please provide valid email address').email('Please provide valid email address'),
  mobile: string().required('Please provide a valid phone number').min(10, 'Please provide a valid phone number').max(10, 'Please provide a valid phone number'),
  alternatePhone: string().test('optional', 'Please provide a valid phone number', value => {
    const stringValue = String(value);
    return stringValue.length === 0 || stringValue.length === 10;
  })
  // employmentAnnualIncomeAmount: string().required(
  //   'Please provide valid income'
  // ),
  // jointWith: string().nullable(),
  // maritalStatusType: string().required('please select marital status'),
  // domesticRelationshipIndicator: boolean()
  //   .transform((value) => !!value)
  //   .when('maritalStatusType', {
  //     is: (value: string) => value.toLowerCase() === 'unmarried',
  //     then: (schema) =>
  //       schema
  //         .transform((value) => !!value)
  //         .required('Please select an option'),
  //   }),
  // domesticRelationshipType: string().when('domesticRelationshipIndicator', {
  //   is: (value: string) => !!value,
  //   then: (schema) => schema.required('Please select the type of relationship'),
  // }),
  // domesticRelationshipStateCode: string().when(
  //   'domesticRelationshipIndicator',
  //   {
  //     is: (value: string) => !!value,
  //     then: (schema) => schema.required('Please select a valid state'),
  //   }
  // ),
  // domesticRelationshipTypeOtherDescription: string().when(
  //   'domesticRelationshipType',
  //   {
  //     is: (value: string) => value && value.toLowerCase() === 'other',
  //     then: (schema) =>
  //       schema.required('Please provide the description of your relationship'),
  //   }
  // ),
  // selfDeclaredMilitaryServiceIndicator: boolean()
  //   .transform((value) => !!value)
  //   .required('Please select an option'),
  // militaryStatusType: string().when('selfDeclaredMilitaryServiceIndicator', {
  //   is: (value: boolean) => value,
  //   then: (schema) => schema.required('Please select a military status'),
  // }),
  // militaryServiceToDate: string().when('militaryStatusType', {
  //   is: (value: string) => value && value.toLowerCase() === 'activeduty',
  //   then: (schema) => schema.required('Please provide a valid date'),
  // }),
});

export default BorrowerInformation;
//# sourceMappingURL=index.js.map